<template>
  <Modal ref="changeViewModal" size="md" width="4" anchor="top" overflow>
    <template #title>
      <h3 class="p-2 text-center mx-auto">{{ dataViewTitle }}</h3>
    </template>
    <template #content>
      <div class="flex flex-col">
        <div class="flex flex-col p-4 mb-2">
          <span>Currently Filtering For</span>
          <div class="w-full border-b-2"></div>
          <div
            v-if="displayData !== undefined">
            <div class="grid grid-cols-5 pl-2"
              v-for="curr in displayData"
              :key="curr.category">
              <span class="col-span-1 text-right text-gray-400"
                v-if="curr.data.length > 0">
                {{ curr.categoryDisplay }}:
              </span>
              <div class="col-span-4 text-left p-1"
                v-if="curr.data.length > 0">
                <div class="flex flex-row flex-wrap">
                  <ItemSmallDisplay
                    v-for="id in curr.data"
                    :key="id"
                    :id="id"
                    :type="curr.category"
                    :canChange="canChange[curr.category]"
                    :canDelete="canDelete[curr.category]"
                    @deleteOption="deleteOption"
                  />
                </div>
              </div>
            </div>
            <div class="flex"
              v-if="displayData.length === 0">
              <div class="pl-4 text-gray-400 uppercase">
                All Data Displaying
              </div>
            </div>
          </div>
          <div
            v-else>
            <span class="uppercase text-red-500 font-bold">
              No View Loaded
            </span>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-12 p-4 mb-2">
          <SelectItemSection
            v-if="!hideSelector.schoolYear"
            callbackId="schoolYear"
            :display="display.schoolYear"
            :canChange="canChange.schoolYear"
            :canDelete="false"
            :canAdd="false"

            :options="options.schoolYear"
            :loadingOptions="loadingOptions.schoolYear"
            :currentData="viewCopy?.getRef().schoolYear"
            :error="errors.schoolYear"
            v-model="schoolYear">
            School Year
          </SelectItemSection>
          <SelectItemSection
            v-if="!hideSelector.partition"
            callbackId="partition"
            :display="display.partition"
            :canChange="canChange.partition"
            :canDelete="canDelete.partition"
            :canAdd="canAdd.partition"

            :options="options.partition"
            :loadingOptions="loadingOptions.partition"
            :currentData="viewCopy?.getRef().partition"
            :error="errors.partition"
            v-model="partitionId"
            @addOption="addOption"
            @deleteOption="deleteOption">
            State/Partition
          </SelectItemSection>
          <SelectItemSection
            v-if="!hideSelector.district"
            callbackId="district"
            :display="display.district"
            :canChange="canChange.district"
            :canDelete="canDelete.district"
            :canAdd="canAdd.district"

            :options="options.district"
            :loadingOptions="loadingOptions.district"
            :currentData="viewCopy?.getRef().district"
            :error="errors.district"
            v-model="districtCode"
            @addOption="addOption"
            @deleteOption="deleteOption">
            District
          </SelectItemSection>
          <SelectItemSection
            v-if="!hideSelector.building"
            callbackId="building"
            :display="display.building"
            :canChange="canChange.building"
            :canDelete="canDelete.building"
            :canAdd="canAdd.building"

            :options="options.building"
            :loadingOptions="loadingOptions.building"
            :currentData="viewCopy?.getRef().building"
            :error="errors.building"
            v-model="buildingId"
            @addOption="addOption"
            @deleteOption="deleteOption">
            Building
          </SelectItemSection>
          <SelectItemSection
            callbackId="vendor"
            :display="display.vendor"
            :canChange="canChange.vendor"
            :canDelete="canDelete.vendor"
            :canAdd="canAdd.vendor"

            :options="options.vendor"
            :loadingOptions="loadingOptions.vendor"
            :currentData="viewCopy?.getRef().vendor"
            :error="errors.vendor"
            v-model="vendorId"
            @addOption="addOption"
            @deleteOption="deleteOption">
            Vendor
          </SelectItemSection>
        </div>
      </div>
    </template>
    <template #footer>
      <SubmitButton
        :submitting="submitting"
        type="button"
        color="blue"
        class="rounded-md px-3 py-2 shadow-sm"
        @click="changeViewSubmit">
        Confirm Changes
      </SubmitButton>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../Modal.vue'
import SubmitButton from '../../SubmitButton.vue'

import SelectItemSection from './SelectItemSection.vue'
import ItemSmallDisplay from './ItemSmallDisplay.vue'

// import settings from '../../../services/settings.js'
// import events from '../../../services/events.js'

import user from '../../../services/user/user.js'
import view from '../../../services/user/view.js'
import events from '../../../services/events.js'

import viewData from '../../../services/viewData/viewData.js'
import district from '../../../services/viewData/district.js'
import partition from '../../../services/viewData/partition.js'

import DROPDOWN_LISTS from '../../DropdownLists.json'

const DISPLAY_MAP = {
  schoolYear: 'School Year',
  district: 'District',
  vendor: 'Vendor',
  partition: 'Partition',
  building: 'Building',
}

export default {
  components: {
    Modal,
    SubmitButton,
    SelectItemSection,
    ItemSmallDisplay,
  },
  props: {},
  data() {
    return {
      dataViewTitle: 'User View',
      user: undefined,
      view: undefined,
      submitting: false,

      viewCopy: undefined,

      schoolYear: undefined,
      vendorId: undefined,
      districtCode: undefined,
      partitionId: undefined,
      buildingId: undefined,

      canChange: {
        schoolYear: false,
        vendor: false,
        district: false,
        partition: false,
        building: false,
      },

      canDelete: {
        vendor: true,
        district: true,
        partition: true,
        building: true,
      },
      canAdd: {
        vendor: true,
        district: true,
        partition: true,
        building: true,
      },

      required: {
        schoolYear: false,
        vendor: false,
        district: false,
        partition: false,
        building: false,
      },

      display: {
        schoolYear: false,
        vendor: false,
        district: false,
        partition: false,
        building: false,
      },

      hideSelector: {
        schoolYear: false,
        vendor: false,
        district: false,
        partition: false,
        building: false,
      },

      loadingOptions: {
        schoolYear: false,
        vendor: false,
        district: false,
        partition: false,
        building: false,
      },

      options: {
        schoolYear: [],
        vendor: [],
        district: [],
        partition: [],
        building: [],
      },

      errors: {
        schoolYear: undefined,
        vendor: undefined,
        district: undefined,
        partition: undefined,
        building: undefined,
      },
    }
  },
  eventCallbackIds: {},
  methods: {
    openModal() {
      this.resetErrors()
      this.$refs.changeViewModal.openModal()

      this.viewCopy = this.view.createCopy()
      this.updateOptions()
      this.updateUser()
    },
    updateUser() {
      user.get().then(_user => {
        this.user = _user
        this.userName = this.user.getFirstName() + ' ' + this.user.getLastName()
        this.dataViewTitle = `${this.userName}'s View`
        console.log(_user)
      })
    },
    addOption(category, value) {
      this.viewCopy.addValue(category, value)

      if (!this.user.can('change_view', { newView: this.viewCopy })) {
        this.$set(this, 'errors', this.user.getCapabilityErrors('change_view'))
        this.viewCopy = this.view.createCopy()
        return
      }
      this.updateOptions()
    },
    deleteOption(category, value) {
      this.viewCopy.removeValue(category, value)

      if (!this.user.can('change_view', { newView: this.viewCopy })) {
        this.$set(this, 'errors', this.user.getCapabilityErrors('change_view'))
        this.viewCopy = this.view.createCopy()
        return
      }
      this.updateOptions()
    },
    async changeViewSubmit() {
      if (!this.user.can('change_view', { newView: this.viewCopy })) {
        this.$set(this, 'errors', this.user.getCapabilityErrors('change_view'))
        this.viewCopy = this.view.createCopy()
        return
      }

      this.submitting = true
      let success = await this.user.updateView(this.viewCopy)
      this.submitting = false

      if (success) {
        this.resetErrors()
        this.$refs.changeViewModal.closeModal()
      } else {
        this.viewCopy = this.view.createCopy()
        this.updateOptions()
      }
    },
    updateOptions() {
      let viewRef = this.viewCopy.getRef()

      if (!this.user.can('change_view', { newView: this.viewCopy })) {
        return
      }

      let capChangeView = this.user.getCapability('change_view')

      let getOptions = {}
      getOptions.schoolYear = this.populateOptionForField(capChangeView, viewRef, 'schoolYear')
      getOptions.vendor = this.populateOptionForField(capChangeView, viewRef, 'vendor')
      getOptions.district = this.populateOptionForField(capChangeView, viewRef, 'district')
      getOptions.partition = this.populateOptionForField(capChangeView, viewRef, 'partition')
      getOptions.building = this.populateOptionForField(capChangeView, viewRef, 'building')

      viewData.getOptionsFromServer(getOptions)
        .then(allOptions => {
          if (allOptions.schoolYear) {
            this.loadingOptions.schoolYear = false
            this.options.schoolYear = this.populateSchoolYearOptions(allOptions.schoolYear)
          }
          if (allOptions.vendor) {
            this.loadingOptions.vendor = false
            this.options.vendor = this.populateVendorOptions(allOptions.vendor)
          }
          if (allOptions.district) {
            this.loadingOptions.district = false
            this.options.district = this.populateDistrictOptions(allOptions.district)
          }
          if (allOptions.partition) {
            this.loadingOptions.partition = false
            this.options.partition = this.populatePartitionOptions(allOptions.partition)
          }
          if (allOptions.building) {
            this.loadingOptions.building = false
            this.options.building = this.populateBuildingOptions(allOptions.building)
          }
        })
    },
    populateOptionForField(capChangeView, viewRef, fieldKey) {
      let getOptions = false

      this.canChange[fieldKey] = capChangeView.displayCanChangeViewField(fieldKey, viewRef)
      this.canDelete[fieldKey] = capChangeView.displayCanDeleteViewField(fieldKey, viewRef)
      this.canAdd[fieldKey] = capChangeView.displayCanAddViewField(fieldKey, viewRef)
      this.required[fieldKey] = capChangeView.requiredChangeViewField(fieldKey, viewRef)

      this.display[fieldKey] = Boolean(viewRef[fieldKey]) || this.canChange[fieldKey]

      this.hideSelector[fieldKey] = !this.canChange[fieldKey] && !this.display[fieldKey]

      if (this.canChange[fieldKey]) {
        this.options[fieldKey] = []
        this.loadingOptions[fieldKey] = true
        getOptions = true
      }

      return getOptions
    },

    populateSchoolYearOptions(schoolYearOptionCodes) {
      return schoolYearOptionCodes.map(option => ({
        value: option.code,
        label: DROPDOWN_LISTS.schoolYears[option.code],
      }))
    },
    populateVendorOptions(vendorCodes) {
      let vendorOptions = vendorCodes.map(option => {
        let _partition = partition.getSync(option.depends.partition)
        return {
          value: option.id,
          label: `${option.data.name} -- ${_partition.data.description}`,
          partitionLabel: _partition.data.description,
        }
      })
      return vendorOptions.sort((a, b) => {
        if (a.partitionLabel < b.partitionLabel) return -1
        if (a.partitionLabel > b.partitionLabel) return 1
        if (a.label < b.label) return -1
        if (a.label > b.label) return 1
        return 0
      })
    },
    populateDistrictOptions(districtCodes) {
      return districtCodes.map(option => {
        return {
          value: option.id,
          label: `${option.id} -- ${option.data.name}`
        }
      })
    },
    populatePartitionOptions(partitionCodes) {
      const options = partitionCodes.map(option => {
        return {
          value: option.id,
          label: `${option.data.description}`
        }
      })
      options.sort((a, b) => a.label.localeCompare(b.label))
      return options
    },
    populateBuildingOptions(buildingCodes) {
      return buildingCodes.map(option => {
        let _district =  undefined
        if (option.depends.district) {
          _district = district.getSync(option.depends.district)
        }
        return {
          value: option.id,
          label: `${option.data.code}, ${option.data.name} -- ${_district?.data.id}`
        }
      })
    },
    resetErrors() {
      let newValue = {
        schoolYear: undefined,
        vendor: undefined,
        district: undefined,
        partition: undefined,
        building: undefined,
      }
      this.user.resetCapabilityErrors('change_view')
      this.$set(this, 'errors', newValue)
    },
    setViewCopyValue(fieldKey, newValue) {
      this.viewCopy.addValue(fieldKey, newValue)

      let capChangeView = this.user.getCapability('change_view')
      let maxSelect = capChangeView.maxSelect(fieldKey)

      if (maxSelect != undefined) {
        let newViewSection = this.viewCopy.viewRef[fieldKey]
        if (newViewSection.length > maxSelect) {
          for (let i = newViewSection.length; i > maxSelect; i--) {
            let indexOf = newViewSection.indexOf(newValue)
            let indexOfOther = (indexOf + 1) % newViewSection.length

            this.viewCopy.removeValue(fieldKey, newViewSection[indexOfOther])
          }
        }
      }

      this.updateOptions()
    }
  },
  computed: {
    displayData() {
      if (this.viewCopy === undefined) return undefined

      let dataRef = this.viewCopy.getRef()
      let _display = []

      for (const key in DISPLAY_MAP) {
        if (dataRef[key]) {
          _display.push({
            categoryDisplay: DISPLAY_MAP[key],
            category: key,
            data: dataRef[key],
          })
        }
      }

      return _display
    },
  },
  watch: {
    schoolYear(newValue) {
      if (this.viewCopy === undefined || newValue === null) return

      //    This would work. The "schoolYear" specific logic is present in `changeView.js`
      // this.setViewCopyValue('schoolYear', newValue)

      let currentYear = this.viewCopy.getSchoolYear()
      if (currentYear !== newValue) {
        this.viewCopy.removeValue('schoolYear', currentYear)
        this.viewCopy.addValue('schoolYear', newValue)
      }
      this.updateOptions()
    },
    vendorId(newValue) {
      if (this.viewCopy === undefined || newValue === null) return
      this.setViewCopyValue('vendor', newValue)
    },
    districtCode(newValue) {
      if (this.viewCopy === undefined || newValue === null) return
      this.setViewCopyValue('district', newValue)
    },
    partitionId(newValue) {
      if (this.viewCopy === undefined || newValue === null) return
      this.setViewCopyValue('partition', newValue)
    },
    buildingId(newValue) {
      if (this.viewCopy === undefined || newValue === null) return
      this.setViewCopyValue('building', newValue)
    },
  },
  async mounted() {
    this.user = await user.get()
    this.view = await view.get()
  },
  created() {
    this.$options.eventCallbackIds.viewUpdated = events.register('viewUpdated', async () => {
      this.view = await view.get()
    })
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    events.remove('viewUpdated', this.$options.eventCallbackIds.viewUpdated)
  }
}
</script>